package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AttachmentQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-282_449_496, arrayOf("attachment"), driver, "Attachment.sq",
      "selectAll",
      "SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment WHERE is_deleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectAll(): Query<Attachment> = selectAll { id, owner_kind, owner_id, file_name,
      mime_type, size_bytes, storage_key, sha256, width, height, status, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Attachment(
      id,
      owner_kind,
      owner_id,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectById(id: String): Query<Attachment> = selectById(id) { id_, owner_kind, owner_id,
      file_name, mime_type, size_bytes, storage_key, sha256, width, height, status, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Attachment(
      id_,
      owner_kind,
      owner_id,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Attachment> = selectByIdAnyState(id) { id_,
      owner_kind, owner_id, file_name, mime_type, size_bytes, storage_key, sha256, width, height,
      status, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Attachment(
      id_,
      owner_kind,
      owner_id,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByOwner(
    owner_kind: String,
    owner_id: String,
    mapper: (
      id: String,
      owner_kind: String,
      owner_id: String,
      file_name: String,
      mime_type: String,
      size_bytes: Long,
      storage_key: String?,
      sha256: String?,
      width: Long?,
      height: Long?,
      status: String,
      order_index: Long,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectByOwnerQuery(owner_kind, owner_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectByOwner(owner_kind: String, owner_id: String): Query<Attachment> =
      selectByOwner(owner_kind, owner_id) { id, owner_kind_, owner_id_, file_name, mime_type,
      size_bytes, storage_key, sha256, width, height, status, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Attachment(
      id,
      owner_kind_,
      owner_id_,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectToUpload(mapper: (
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long,
  ) -> T): Query<T> = Query(1_140_604_085, arrayOf("attachment"), driver, "Attachment.sq",
      "selectToUpload", """
  |SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment
  |WHERE status = 'pending' AND is_deleted = 0 AND synced_at IS NOT NULL AND synced_at >= updated_at
  """.trimMargin()) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)!!
    )
  }

  public fun selectToUpload(): Query<SelectToUpload> = selectToUpload { id, owner_kind, owner_id,
      file_name, mime_type, size_bytes, storage_key, sha256, width, height, status, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    SelectToUpload(
      id,
      owner_kind,
      owner_id,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-848_335_335, arrayOf("attachment"), driver, "Attachment.sq",
      "selectDirty",
      "SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectDirty(): Query<Attachment> = selectDirty { id, owner_kind, owner_id, file_name,
      mime_type, size_bytes, storage_key, sha256, width, height, status, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Attachment(
      id,
      owner_kind,
      owner_id,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByOwnerKind(owner_kind: String, mapper: (
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByOwnerKindQuery(owner_kind) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8),
      cursor.getLong(9),
      cursor.getString(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectByOwnerKind(owner_kind: String): Query<Attachment> =
      selectByOwnerKind(owner_kind) { id, owner_kind_, owner_id, file_name, mime_type, size_bytes,
      storage_key, sha256, width, height, status, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Attachment(
      id,
      owner_kind_,
      owner_id,
      file_name,
      mime_type,
      size_bytes,
      storage_key,
      sha256,
      width,
      height,
      status,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun selectResourceShas(skill_id: String): Query<String> =
      SelectResourceShasQuery(skill_id) { cursor ->
    cursor.getString(0)!!
  }

  public fun insert(
    id: String,
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_581_076_746, """
        |INSERT INTO attachment(
        |    id, owner_kind, owner_id, file_name, mime_type, size_bytes, storage_key, sha256,
        |    width, height, status, order_index, created_at, updated_at
        |) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 14) {
          bindString(0, id)
          bindString(1, owner_kind)
          bindString(2, owner_id)
          bindString(3, file_name)
          bindString(4, mime_type)
          bindLong(5, size_bytes)
          bindString(6, storage_key)
          bindString(7, sha256)
          bindLong(8, width)
          bindLong(9, height)
          bindString(10, status)
          bindLong(11, order_index)
          bindLong(12, created_at)
          bindLong(13, updated_at)
        }
    notifyQueries(-1_581_076_746) { emit ->
      emit("attachment")
    }
  }

  public fun update(
    owner_kind: String,
    owner_id: String,
    file_name: String,
    mime_type: String,
    size_bytes: Long,
    storage_key: String?,
    sha256: String?,
    width: Long?,
    height: Long?,
    status: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_236_130_554, """
        |UPDATE attachment
        |SET owner_kind = ?, owner_id = ?, file_name = ?, mime_type = ?, size_bytes = ?, storage_key = ?,
        |    sha256 = ?, width = ?, height = ?, status = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 13) {
          bindString(0, owner_kind)
          bindString(1, owner_id)
          bindString(2, file_name)
          bindString(3, mime_type)
          bindLong(4, size_bytes)
          bindString(5, storage_key)
          bindString(6, sha256)
          bindLong(7, width)
          bindLong(8, height)
          bindString(9, status)
          bindLong(10, order_index)
          bindLong(11, updated_at)
          bindString(12, id)
        }
    notifyQueries(-1_236_130_554) { emit ->
      emit("attachment")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(894_936_114,
        """UPDATE attachment SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3)
        {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(894_936_114) { emit ->
      emit("attachment")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_666_608_625,
        """UPDATE attachment SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_666_608_625) { emit ->
      emit("attachment")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(2_097_829_732,
        """UPDATE attachment SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(2_097_829_732) { emit ->
      emit("attachment")
    }
  }

  public fun dropUnsent(
    deleted_at: Long?,
    updated_at: Long,
    synced_at: Long?,
    owner_kind: String,
    owner_id: String,
  ) {
    driver.execute(-1_834_132_675,
        """UPDATE attachment SET is_deleted = 1, deleted_at = ?, updated_at = ?, synced_at = ? WHERE owner_kind = ? AND owner_id = ?""",
        5) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindLong(2, synced_at)
          bindString(3, owner_kind)
          bindString(4, owner_id)
        }
    notifyQueries(-1_834_132_675) { emit ->
      emit("attachment")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("attachment", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("attachment", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-165_958_485,
        """SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Attachment.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("attachment", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("attachment", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_648_237_616,
        """SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Attachment.sq:selectByIdAnyState"
  }

  private inner class SelectByOwnerQuery<out T : Any>(
    public val owner_kind: String,
    public val owner_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("attachment", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("attachment", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-555_652_829,
        """SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment WHERE owner_kind = ? AND owner_id = ? AND is_deleted = 0 ORDER BY order_index, created_at""",
        mapper, 2) {
      bindString(0, owner_kind)
      bindString(1, owner_id)
    }

    override fun toString(): String = "Attachment.sq:selectByOwner"
  }

  private inner class SelectByOwnerKindQuery<out T : Any>(
    public val owner_kind: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("attachment", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("attachment", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_343_606_615,
        """SELECT attachment.id, attachment.owner_kind, attachment.owner_id, attachment.file_name, attachment.mime_type, attachment.size_bytes, attachment.storage_key, attachment.sha256, attachment.width, attachment.height, attachment.status, attachment.order_index, attachment.created_at, attachment.updated_at, attachment.is_deleted, attachment.deleted_at, attachment.synced_at FROM attachment WHERE owner_kind = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, owner_kind)
    }

    override fun toString(): String = "Attachment.sq:selectByOwnerKind"
  }

  private inner class SelectResourceShasQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("attachment", "skill_resource", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("attachment", "skill_resource", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_296_711_090, """
    |SELECT a.sha256 FROM attachment a
    |JOIN skill_resource r ON r.id = a.owner_id
    |WHERE a.owner_kind = 'skill_resource' AND a.is_deleted = 0 AND a.sha256 IS NOT NULL
    |  AND r.is_deleted = 0 AND r.push_error IS NULL AND r.skill_id = ?
    """.trimMargin(), mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "Attachment.sq:selectResourceShas"
  }
}
